import { ScribeApiError, ScribeNetworkError } from "../client/errors.js";
/**
 * Default error classifier used by the upload queue when the caller doesn't supply one.
 *
 * Retryable: network failures, request timeouts/aborts-by-us, 429, and 5xx.
 * Not retryable: 4xx other than 429 (e.g. expired/invalid presigned URL -> 403,
 * malformed request -> 400) — these won't succeed on retry without re-issuing the
 * presigned upload, so the FSM surfaces them as a permanent failure instead of
 * burning through backoff attempts.
 */
export const defaultClassifyError = (error) => {
    if (error instanceof ScribeNetworkError) {
        return { retryable: true, reason: `network_error: ${error.message}` };
    }
    if (error instanceof ScribeApiError) {
        if (error.status === 429 || error.status >= 500) {
            return { retryable: true, reason: `http_${error.status}: ${error.message}` };
        }
        return { retryable: false, reason: `http_${error.status}: ${error.message}` };
    }
    // Generic fetch-style errors (e.g. S3 PUT failures surfaced as plain Error/DOMException).
    if (isLikelyHttpStatusError(error)) {
        const status = error.status;
        if (status === 429 || status >= 500) {
            return { retryable: true, reason: `http_${status}` };
        }
        return { retryable: false, reason: `http_${status}` };
    }
    if (error instanceof DOMException && error.name === "AbortError") {
        return { retryable: true, reason: "aborted" };
    }
    if (error instanceof Error) {
        return { retryable: true, reason: error.message };
    }
    return { retryable: true, reason: "unknown_error" };
};
function isLikelyHttpStatusError(error) {
    return (typeof error === "object" &&
        error !== null &&
        "status" in error &&
        typeof error.status === "number");
}
//# sourceMappingURL=errors.js.map